/**
 * L4 model-code normalization — a verbatim copy of admin-api's normalizeModel (itself in parity
 * with the App's Python normalize_model). The dashboard only uses it to PREVIEW the matching code
 * in the add-model dialog; the Worker computes the stored key. Kept identical so the preview never
 * lies (models.test.ts pins the same cases).
 */
export function normalizeModel(raw: string): string {
  return raw
    .toUpperCase()
    .trim()
    .replace(/[^A-Z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}
